import {
    TextEncoder
} from 'text-encoding';

import {
    defineMessages
} from 'react-intl';

import C1 from './defaultRobot/C1.svg';
import openC1 from './defaultRobot/openC1.svg';

import E6 from './defaultRobot/E6.svg';
import openE6 from './defaultRobot/openE6.svg';

// import E3 from './defaultRobot/E3.svg';
// import openE3 from './defaultRobot/openE3.svg';

import E3 from './defaultRobot/E3-1508.svg';
import openE3 from './defaultRobot/openE3-1508.svg';

import M6 from './defaultRobot/M6.svg';
import openM6 from './defaultRobot/openM6.svg';

import C6 from './defaultRobot/C6.svg';
import openC6 from './defaultRobot/openC6.svg';

import A2 from './defaultRobot/A2.svg';
import openA2 from './defaultRobot/openA2.svg';

import E7_HRCU from './defaultRobot/E7-HRCU.svg';
import openE7_HRCU from './defaultRobot/openE7-HRCU.svg';

import Storm_os from './defaultRobot/Storm_os.svg';
import openStorm_os from './defaultRobot/openStorm_os.svg';


import M5 from './defaultRobot/M5.svg';
import openM5 from './defaultRobot/openM5.svg';


let messages = defineMessages({
    E6: {
        defaultMessage: 'E6 控制器',
        description: 'Switch to Intelligent Storm',
        id: 'gui.gui.E6'
    },
    C1: {
        defaultMessage: 'C1 控制器',
        description: 'Switch to Cheng Chi-1 ',
        id: 'gui.gui.C1'
    },
    E3: {
        defaultMessage: 'E3 控制器',
        description: 'Switch to Cheng Chi-1 ',
        id: 'gui.gui.E3'
    },
    M6: {
        defaultMessage: 'M6 控制器',
        description: 'Switch to Cheng Chi-1 ',
        id: 'gui.gui.M6'
    },
    A2: {
        defaultMessage: 'A2 控制器',
        description: 'Switch A2',
        id: 'gui.gui.A2'
    },
    C6: {
        defaultMessage: 'C6 控制器',
        description: 'Switch C6',
        id: 'gui.gui.C6'
    },
    M5:{
        defaultMessage: 'M5 控制器',
        description: 'Switch M5',
        id: 'gui.gui.M5'
    }
});

const encoder = new TextEncoder()

const robotSuit = (translator) => {
    return ([{
            isStage: false,
            isRobot: true,
            robotType: 'E6',
            name: translator(messages.E6, {
                index: 1
            }),
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            currentCostume: 0,
            imgurl: E6,
            openimgurl: openE6,
            costumes: [{
                assetId: '3696356a03a8d93831bb76a593515243',
                name: '造型1',
                bitmapResolution: 1,
                md5ext: '3696356a03a8d93831bb76a593515243.svg',
                dataFormat: 'svg',
                rotationCenterX: 48,
                rotationCenterY: 50
            }],
            sounds: [{
                assetId: '83c36d806dc92327b9e7049a565c6bff',
                name: '声音1',
                dataFormat: 'wav',
                format: '',
                rate: 22050,
                sampleCount: 18688,
                md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
            }],
            volume: 100,
            visible: false,
            x: 0,
            y: 0,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: 'all around'
        },
        {
            isStage: false,
            isRobot: true,
            robotType: 'C1',
            name: translator(messages.C1, {
                index: 1
            }),
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            currentCostume: 0,
            imgurl: C1,
            openimgurl: openC1,
            costumes: [{
                assetId: '3696356a03a8d93831ab76a593515244',
                name: '造型1',
                bitmapResolution: 1,
                md5ext: '3696356a03a8d93831ab76a593515244.svg',
                dataFormat: 'svg',
                rotationCenterX: 48,
                rotationCenterY: 50
            }],
            sounds: [{
                assetId: '83c36d806dc92327b9e7049a565c6bff',
                name: '声音1',
                dataFormat: 'wav',
                format: '',
                rate: 22050,
                sampleCount: 18688,
                md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
            }],
            volume: 100,
            visible: false,
            x: 0,
            y: 0,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: 'all around'
        },
        {
            isStage: false,
            isRobot: true,
            robotType: 'E3',
            name: translator(messages.E3, {
                index: 1
            }),
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            currentCostume: 0,
            imgurl: E3,
            openimgurl: openE3,
            costumes: [{
                assetId: '3696356a03a8d93831ab76a593515246',
                name: '造型1',
                bitmapResolution: 1,
                md5ext: '3696356a03a8d93831ab76a593515246.svg',
                dataFormat: 'svg',
                rotationCenterX: 48,
                rotationCenterY: 50
            }],
            sounds: [{
                assetId: '83c36d806dc92327b9e7049a565c6bff',
                name: '声音1',
                dataFormat: 'wav',
                format: '',
                rate: 22050,
                sampleCount: 18688,
                md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
            }],
            volume: 100,
            visible: false,
            x: 0,
            y: 0,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: 'all around'
        },
        {
            isStage: false,
            isRobot: true,
            robotType: 'M6',
            name: translator(messages.M6, {
                index: 1
            }),
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            currentCostume: 0,
            imgurl: M6,
            openimgurl: openM6,
            costumes: [{
                assetId: '9696356a03a8d93831ab76a593515247',
                name: '造型1',
                bitmapResolution: 1,
                md5ext: '9696356a03a8d93831ab76a593515247.svg',
                dataFormat: 'svg',
                rotationCenterX: 48,
                rotationCenterY: 50
            }],
            sounds: [{
                assetId: '83c36d806dc92327b9e7049a565c6bff',
                name: '声音1',
                dataFormat: 'wav',
                format: '',
                rate: 22050,
                sampleCount: 18688,
                md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
            }],
            volume: 100,
            visible: false,
            x: 0,
            y: 0,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: 'all around'
        },
        // {
        //     isStage: false,
        //     isRobot: true,
        //     robotType: 'C6',
        //     name: translator(messages.C6, {
        //         index: 1
        //     }),
        //     variables: {},
        //     lists: {},
        //     broadcasts: {},
        //     blocks: {},
        //     currentCostume: 0,
        //     imgurl: C6,
        //     openimgurl: openC6,
        //     costumes: [{
        //         assetId: '3696356a03a8d93831ab76a593515257',
        //         name: '造型1',
        //         bitmapResolution: 1,
        //         md5ext: '3696356a03a8d93831ab76a593515257.svg',
        //         dataFormat: 'svg',
        //         rotationCenterX: 48,
        //         rotationCenterY: 50
        //     }],
        //     sounds: [{
        //         assetId: '83c36d806dc92327b9e7049a565c6bff',
        //         name: '声音1',
        //         dataFormat: 'wav',
        //         format: '',
        //         rate: 22050,
        //         sampleCount: 18688,
        //         md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
        //     }],
        //     volume: 100,
        //     visible: false,
        //     x: 0,
        //     y: 0,
        //     size: 100,
        //     direction: 90,
        //     draggable: false,
        //     rotationStyle: 'all around'
        // },
        // {
        //     isStage: false,
        //     isRobot:true,
        //     robotType:'A2',
        //     name: translator(messages.A2, {index: 1}),
        //     variables: {},
        //     lists: {},
        //     broadcasts: {},
        //     blocks: {},
        //     currentCostume: 0,
        //     imgurl:A2,
        //     openimgurl:openA2,
        //     costumes: [
        //         {
        //             assetId: '3696356a03a8d93831ab76a593515243',
        //             name: '造型1',
        //             bitmapResolution: 1,
        //             md5ext: '3696356a03a8d93831ab76a593515243.png',
        //             dataFormat: 'png',
        //             rotationCenterX: 48,
        //             rotationCenterY: 50
        //         }
        //     ],
        //     sounds: [
        //         {
        //             assetId: '83c36d806dc92327b9e7049a565c6bff',
        //             name: '声音1',
        //             dataFormat: 'wav',
        //             format: '',
        //             rate: 22050,
        //             sampleCount: 18688,
        //             md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
        //         }
        //     ],
        //     volume: 100,
        //     visible: false,
        //     x: 0,
        //     y: 0,
        //     size: 100,
        //     direction: 90,
        //     draggable: false,
        //     rotationStyle: 'all around'
        // }
        , {
            isStage: false,
            isRobot: true,
            robotType: 'E7',
            name: "H-RCU",
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            currentCostume: 0,
            imgurl: E7_HRCU,
            openimgurl: openE7_HRCU,
            costumes: [{
                assetId: '3696356a03a8d93831ab76a593515245',
                name: '造型1',
                bitmapResolution: 1,
                md5ext: '3696356a03a8d93831ab76a593515245.svg',
                dataFormat: 'svg',
                rotationCenterX: 48,
                rotationCenterY: 50
            }],
            sounds: [{
                assetId: '83c36d806dc92327b9e7049a565c6bff',
                name: '声音1',
                dataFormat: 'wav',
                format: '',
                rate: 22050,
                sampleCount: 18688,
                md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
            }],
            volume: 100,
            visible: false,
            x: 0,
            y: 0,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: 'all around'
        },
        // {
        //     isStage: false,
        //     isRobot: true,
        //     robotType: 'STORM_OS',
        //     name: "SenseStorm3",
        //     variables: {},
        //     lists: {},
        //     broadcasts: {},
        //     blocks: {},
        //     currentCostume: 0,
        //     imgurl: Storm_os,
        //     openimgurl: openStorm_os,
        //     costumes: [{
        //         assetId: '3696356a03a8d93831ab76a593515255',
        //         name: '造型1',
        //         bitmapResolution: 1,
        //         md5ext: '3696356a03a8d93831ab76a593515255.svg',
        //         dataFormat: 'svg',
        //         rotationCenterX: 48,
        //         rotationCenterY: 50
        //     }],
        //     sounds: [{
        //         assetId: '83c36d806dc92327b9e7049a565c6bff',
        //         name: '声音1',
        //         dataFormat: 'wav',
        //         format: '',
        //         rate: 22050,
        //         sampleCount: 18688,
        //         md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
        //     }],
        //     volume: 100,
        //     visible: false,
        //     x: 0,
        //     y: 0,
        //     size: 100,
        //     direction: 90,
        //     draggable: false,
        //     rotationStyle: 'all around'
        // },
        {
            isStage: false,
            isRobot: true,
            robotType: 'M5',
            name: translator(messages.M5, {
                index: 1
            }),
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            currentCostume: 0,
            imgurl: M5,
            openimgurl: openM5,
            costumes: [{
                assetId: '3696356a03a8d93831ab76a593515256',
                name: '造型1',
                bitmapResolution: 1,
                md5ext: '3696356a03a8d93831ab76a593515256.svg',
                dataFormat: 'svg',
                rotationCenterX: 48,
                rotationCenterY: 50
            }],
            sounds: [{
                assetId: '83c36d806dc92327b9e7049a565c6bff',
                name: '声音1',
                dataFormat: 'wav',
                format: '',
                rate: 22050,
                sampleCount: 18688,
                md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
            }],
            volume: 100,
            visible: false,
            x: 0,
            y: 0,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: 'all around'
        }
    ])
}


export default robotSuit
